import React, { createContext, useState, useContext, ReactNode } from "react";
import { useTranslation } from "react-i18next";

// Define the shape of the media state
interface MediaContextType {
  playingMediaInfo: any;
  setPlayingMediaInfo: (info: any) => void;
  isPlaying: boolean;
  setIsPlaying: (isPlaying: boolean) => void;
}

// Create the context
const MediaContext = createContext<MediaContextType | undefined>(undefined);

// Custom hook for using context
export const useMediaContext = () => {
  const { t } = useTranslation();
  const context = useContext(MediaContext);
  if (!context) {
    throw new Error(t("useMediaContext must be used within a MediaProvider"));
  }
  return context;
};

// Provider Component
export const MediaProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [playingMediaInfo, setPlayingMediaInfo] = useState<any>({});
  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  return (
    <MediaContext.Provider
      value={{ playingMediaInfo, setPlayingMediaInfo, isPlaying, setIsPlaying }}
    >
      {children}
    </MediaContext.Provider>
  );
};
